import React, { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap/dist/gsap';
import Image from 'next/image';
import bgImage from '../../../../public/images/home-section3.jpg';
import mbImage from '../../../../public/images/mobile/section3.jpg';
import poster from '../../../../public/images/videog.jpg';
import styles from './section2.module.scss';
import play from '../../../../public/images/play-small.svg';
import buttonBg from '../../../../public/images/button-bg.png';
// Import Swiper Use
import { useSwiper, useSwiperSlide } from 'swiper/react';
import Magnetic from '../../magicButton';
import playClick from '../../actions/default-click';
import videoHover from '../../actions/video-hover';
import playHover from '../../actions/default-hover';
import SectionBg from '../sectionBg';
import Arrow from '../../icons/arrow';

function Section2({music}) {
    const screenWidth = window.innerWidth;
    let pageBG = screenWidth < 767 ? mbImage : bgImage;
    const bgData = {
        bgImage: pageBG
    }
    const videoData = {
        video: process.env.NEXT_PUBLIC_ASSETS_URL+"/video/hiding-video.mp4",
        poster: poster,
        buttonText: 'להמשיך לתערוכה',
    };
    // Use State
    const [playVideo, setPlayvideo] = useState(false);
    const video = useRef(null);
    function isMusicPlaying(audelem) { return !audelem?.paused; }
    //const videoPlay = useRef(null);
    const playVideoClick = (data) => {
        if(data) {
            setPlayvideo(true);
        } else {
            setPlayvideo(false);
        }
    }
    if(video.current) {
        video.current.onplay = () => {
            setPlayvideo(true);
        }
        video.current.onpause = () => {
            setPlayvideo(false);
        }
    }
    // On Video Play/Pause
    useEffect(() => {
        // get the background player
        const backAudio = localStorage.getItem('backgroundMusic');
        //console.log(playVideo);
        if(playVideo) {
            // Background Music
            if(isMusicPlaying(music) && backAudio === "playing") {
                video.current.play();
                gsap.to(video.current, {volume: 1, duration: 2});
                // BG Music
                gsap.to(music, {volume: 0, duration: 1.5, onComplete: () => {
                  music.pause();
                }});
            } else {
                video.current.play();
                video.current.volume = 1;
            }
        } else {
            // Background Music
            if(!isMusicPlaying(music) && backAudio === "playing") {
                gsap.to(video.current, {volume: 0, duration: 1.5, onComplete: () => {
                    video.current.pause();
                }});
                // BG Music
                music.play();
                gsap.to(music, {volume: 1, duration: 2});
            } else {
                video.current.pause();
            }
        }
    }, [playVideo, music]);
    // Swiper 
    const swiper = useSwiper();
    const swiperSlide = useSwiperSlide();
    // GSAP Split text
    useEffect(() => { 
        gsap.set('.section-video', {scale: 1.5, opacity: 0}); 
        gsap.set('.button', {y: 100, opacity: 0});
        gsap.set('.closeBtn', {y: -100, opacity: 0});
        if(swiperSlide.isActive){
            gsap.to('.section-video', {scale:1, opacity: 1, ease:"ease.inOut", duration: 1, delay:0 })
            gsap.to('.button', {y:0, opacity: 1, ease:"ease.inOut", duration: 1, delay:0.4 })
            gsap.to('.closeBtn', {y:0, opacity: 1, ease:"ease.inOut", duration: 1, delay:0.6 })
        }

        // On End Video
        if(video.current) {
            video.current.addEventListener("ended", () => {
                swiper.slideNext();
            }, false);
        }
    }, [swiperSlide.isActive]);
    
  return (
    <>
        {screenWidth < 767 && <SectionBg data={bgData} />}
        <div className={`section-wrapper flex flex-wrap relative z-20 ${styles.wrapper}`}>
            <div className={`section-video w-full h-full relative ${styles.video} ${playVideo && "playing"}`}>
                <button 
                onClick={() => {
                    playClick();
                    playVideoClick(false);
                    swiper.slidePrev();
                }} 
                onMouseEnter={() => {
                    playHover();
                }}
                className={`absolute closeBtn z-50 ${styles.closeButton}`}>
                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M25.8334 2.75297L23.2484 0.167969L13.0001 10.4163L2.75175 0.167969L0.166748 2.75297L10.4151 13.0013L0.166748 23.2496L2.75175 25.8346L13.0001 15.5863L23.2484 25.8346L25.8334 23.2496L15.5851 13.0013L25.8334 2.75297Z" fill="white"/>
                    </svg>
                </button>
                <video 
                ref={video}
                poster={videoData.poster.src}
                controls
                controlsList={`nodownload ${screenWidth > 767 && 'nofullscreen'}`}
                className='w-full h-full overflow-hidden z-10 relative object-cover' 
                preload="none">
                    <source src={videoData.video} type="video/mp4" />
                </video>
                <div className={`z-40 absolute top-0 right-0 w-full overflow-hidden ${styles.videoOverlay} ${playVideo && "hidden"}`}>
                    <button 
                    onClick={() => {
                        playVideoClick(!playVideo);
                        playClick();
                    }} 
                    onMouseEnter={() => videoHover()}
                    className={`play-btn fixed left-1/2 top-1/2 z-20 rounded-full transition-colors ${styles.playButton}`}>
                        <Image src={play} alt={'Play'} />
                    </button>
                </div>
            </div>
            
            <Magnetic 
            className={`absolute button inline-block mr-auto p-10 z-50 ${styles.magnetic}`}>
                <button 
                onClick={() => {
                    swiper.slideNext()
                    playClick();
                    setPlayvideo(false);
                }}
                onMouseEnter={() => {
                  playHover();
                }}
                className={`${styles.button}`}>{videoData.buttonText}</button>
            </Magnetic>

            <div className={`button flex justify-center w-full ${styles.nextPage}`}>
                <button 
                onClick={() => {
                    swiper.slideNext()
                    playClick();
                }}
                onMouseEnter={() => {
                  playHover();
                }}
                className={`flex items-center ${styles.button}`}>
                    <span className={styles.text}>רוצים לפגוש עוד סיפורים?</span>
                    <span className={`flex items-center justify-center ${styles.icon}`} style={{backgroundImage: `url(${buttonBg.src})`}}>
                        <Arrow />
                    </span>
                </button>
            </div>
        </div>
    </>
  )
}

export default Section2